import { numberFieldStyles as fastNumberFieldStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationNumberFieldStyles = (context, definition) => css `
  ${fastNumberFieldStyles(context, definition)}
  ::part(label) {
    color: var(--neutral-foreground-rest);
  }

  fast-text-field {
    display: unset;
  }

  .controls {
    margin-bottom: auto;
    margin-inline-end: 5px;
    margin-top: auto;
  }

  .step-down,
  .step-up {
    display: block;
    fill: var(--neutral-foreground-rest);
  }

  .step-down-glyph,
  .step-up-glyph {
    padding: unset;
  }

  ::part(end) {
    margin-inline-end: unset;
  }
`;
